import React from 'react';
import Card from 'react-bootstrap/Card';


const SiteDescription = (props) => {

  return (
    <Card className={"mb-2"}>
      <Card.Body>
        <p>
          Learning Python? One of the best ways to hone your skills is to contribute to
          free/open-source software. This site lists open issues on GitHub repositories
          using Python that have been marked as "beginner friendly".
        </p>
        If you would like your project added to/removed from this list, please send an email to
        rjw_software@protonmail.com .
      </Card.Body>
    </Card>
  )
};


export default SiteDescription;
